import {ValueObject} from '@s-ui/domain'

export class GetVehiclesInfoByPlateRequest extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.plate
   **/

  static validate({config, plate, genericVehiclesErrorFactory}) {
    const REGEX_CAR_PLATE = config.get('REGEX_CAR_PLATE')

    if (!plate || !REGEX_CAR_PLATE.test(plate)) {
      throw genericVehiclesErrorFactory('Plate is not valid.')
    }
  }
}
